<template>
  <v-dialog v-model="dialog" hide-overlay persistent width="400">
    <v-card color="primary" dark>
      <v-card-text class="text-center">
        <template v-if="CustomerTotal <= maxDownloadableRows">
          <div class="pt-2 pb-3">Preparing CSV file</div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </template>
        <template v-else>
          <div class="pt-2">
            There are more than {{ maxDownloadableRows }} records matching your current query. Please narrow down your
            filters.
          </div>
          <v-row justify="center" class="pt-2">
            <v-btn @click="$emit('update:show', false)">Close</v-btn>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { saveBlobToFile } from '@/utils/fileHelpers';

export default {
  name: 'customer-export-dialog',
  props: ['show'],
  data: () => ({
    maxDownloadableRows: 5000
  }),
  computed: {
    ...mapGetters(['CustomerTotal']),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: mapActions(['downloadCustomers']),
  watch: {
    show(val) {
      if (val && this.CustomerTotal <= this.maxDownloadableRows) {
        this.downloadCustomers().then(response => {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          saveBlobToFile(blob, 'abf-customers-export.csv');
          this.dialog = false;
        });
      }
    }
  }
};
</script>
